module.exports = __webpack_public_path__ + "static/img/app1.873278d5.png";